import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Footer() {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith('/dashboard') || 
                          location.pathname.startsWith('/search') || 
                          location.pathname.startsWith('/emails') ||
                          location.pathname.startsWith('/replies') ||
                          location.pathname.startsWith('/'); 

  return (
    <footer className={`${isDashboardRoute ? 'bg-gray-800' : 'bg-white'} mt-auto`}>
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div>
            <h3 className={`text-sm font-semibold ${isDashboardRoute ? 'text-gray-300' : 'text-gray-400'} tracking-wider uppercase`}>
              Product
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/docs" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/examples" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Examples
                </Link>
              </li>
              <li>
                <Link to="/pricing" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className={`text-sm font-semibold ${isDashboardRoute ? 'text-gray-300' : 'text-gray-400'} tracking-wider uppercase`}>
              Company
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Careers
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className={`text-sm font-semibold ${isDashboardRoute ? 'text-gray-300' : 'text-gray-400'} tracking-wider uppercase`}>
              Resources
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Developer API
                </Link>
              </li>
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  GitHub
                </Link>
              </li>
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Discord
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className={`text-sm font-semibold ${isDashboardRoute ? 'text-gray-300' : 'text-gray-400'} tracking-wider uppercase`}>
              Legal
            </h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/tmp" className={`text-base ${isDashboardRoute ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'}`}>
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8">
          <p className={`text-base ${isDashboardRoute ? 'text-gray-400' : 'text-gray-400'} xl:text-center`}>
            &copy; {new Date().getFullYear()} Research-X. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}